import {
  ActiveRecord,
  FormFieldWidget,
  FormM2OSelectFieldWidget,
  IQueryPageOption,
  IQueryPageResult,
  ModelFieldType,
  RuntimeModel,
  SPI,
  ViewType,
  Widget,
  http
} from '@kunlun/dependencies';
import { fetchLogisticsProviders } from '../../../../api';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToOne,
    model: ['deli.aries.seller.DeliAriesSellerPurchasingPlan'],
    name: 'ariesLogisticsProvider',
    multi: false
  })
)
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToOne,
    model: [
      'deli.aries.seller.SellerDistributionCreateOrderParam',
      'deli.aries.seller.SellerDistributorAuditOrderParam'
    ],
    name: 'expectedLogisticsProvider',
    multi: false
  })
)
export class FormEnumLogisticCompanyFieldWidget extends FormM2OSelectFieldWidget {
  public initialize(props) {
    super.initialize(props);
    // this.setComponent(ProxyDelivery);
    return this;
  }

  protected async loadOptions(param?: IQueryPageOption | undefined) {
    const content = {
      content: [],
      totalPages: 0,
      totalElements: 0,
      size: 0
    } as IQueryPageResult<Record<string, unknown>>;

    const ariesIssuingMethodEnum = (this.formData.ariesIssuingMethodEnum || this.formData.issuingMethod) as string;

    content.content = await fetchLogisticsProviders(this.model, {
      ariesIssuingMethodEnum
    });

    return content;
  }

  @Widget.Watch('formData.ariesIssuingMethodEnum')
  protected async watchAriesIssuingMethodEnum(value: string) {
    if (value) {
      await this.initLoadOptions();
      if (this.model.model === 'deli.aries.seller.SellerDistributorAuditOrderParam'|| this.model.model==='deli.aries.seller.DeliAriesSellerPurchasingPlan') {
        if (this.options.every((i) => i.value !== this.value?.code)) {
          this.change(this.options[0]);
        }
      } else {
        if (this.options.every((i) => i.code !== this.value?.code)) {
          this.change(this.options[0]);
        }
      }
    }
  }

  // 要货计划字段：
  // 代发方式 issuingMethod
  @Widget.Watch('formData.issuingMethod')
  protected async watchIssuingMethod(value: string) {
    if (value) {
      await this.initLoadOptions();
      if (this.model.model === 'deli.aries.seller.SellerDistributorAuditOrderParam'|| this.model.model==='deli.aries.seller.DeliAriesSellerPurchasingPlan') {
        if (this.options.every((i) => i.value !== this.value?.code)) {
          this.change(this.options[0]);
        }
      } else {
        if (this.options.every((i) => i.code !== this.value?.code)) {
          this.change(this.options[0]);
        }
      }
    }
  }
}
